import React from 'react';
import { Modal } from '../../../../components';
import { CheckCircle } from '@phosphor-icons/react';

const TicketVerified = ({ ticketImg, eventName, eventDate, eventTime, eventLocation, ticketCount, totalAmt }) => {
  return (
    <Modal className='verify-ticket'>
      <div className="flex flex-col items-center justify-start py-6 px-2 bg-light-green rounded-lg shadow-xlw-full max-w-md">
        <div className='flex flex-col gap-3 items-center'>
          <CheckCircle color='#009D64' 
            weight='fill'
            size='48' /> 
          <div className="heading-16 text-primary-green text-center w-3/4 pb-6">Wohoo! Your tickets have been verified!</div>
        </div>
        <div className='flex flex-col bg-white rounded-xl pt-3 shadow-xl'>
          <div className="w-full h-32 rounded-sm mb-4 px-3">
            <img src={ticketImg} 
              alt="Verified Ticket"
              className='w-[290px] h-[140px] rounded-sm object-cover'/>
          </div>
          <div className='flex flex-col gap-2 pt-11 px-3 pb-3'>
            <div className="w-full heading-16">{eventName}</div>
            <div className="w-full text-14 flex items-center">{eventDate} . {eventTime}</div>
            <div className="w-full text-14">{eventLocation}</div>
            <div className="w-full text-14">{ticketCount} {ticketCount > 1 ? 'tickets' : 'ticket'}</div>
          </div>

          <div className='bg-light-green rounded-b-xl w-full px-4 py-3 flex justify-between '>
            <div className='text-14'>Total Amount</div>
            <div className='label-16'>₹ {totalAmt}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TicketVerified;
